// FilePreviewModal.js
import React from "react";
import { Modal } from "react-bootstrap";
import ButtonComp from "../_helpers/Button";

// Modal.setAppElement('#root'); // Set the root element for accessibility

const FilePreview = ({ isOpen, onRequestClose, fileUrl, newAdded }) => {

  let extension = fileUrl?.split(".").pop().toLowerCase();
  let extensionArray = ["pdf", "jpg", "png", "gif", "jpeg"];
  let allowp;
  if (extensionArray.includes(extension)) {
    allowp = true;
  } else {
    allowp = false
  }
  let FIleURL;
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    if (newAdded) {
      FIleURL = fileUrl;
    } else {
      FIleURL = process.env.REACT_APP_IMAGE_BASE_URL + "/" + fileUrl;
    }
  } else {
    FIleURL = fileUrl;
  }
  return (
    <Modal
      size={allowp ? "lg" : "sm"}
      show={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="File Preview"
    >
      <Modal.Body>
        {allowp && (
          <iframe
            title="File Preview"
            src={FIleURL}
            width="100%"
            height="600px"
          />
        )}
        {
          !allowp && (
            <h4>File ({extension}) Not Supported </h4>
          )}
      </Modal.Body>
      <Modal.Footer>
        <ButtonComp
          variant="secondary"
          endPoint="/MasterXMLInfo"
          id={null}
          submitFunc={onRequestClose}
          type="Close"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default FilePreview;
